module.exports = __webpack_public_path__ + "static/media/usg-eth-button.53cae16b.png";